
export const HTMLConst = {
  headerName: 'headerName',
  headerPosition1: 'headerPosition1',
  headerUnderlineTarget: 'headerUnderlineTarget',
  sendButtonTarget: 'sendButtonTarget',
};
